import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TenantState = {
  id: number;
  name: string;
  siteTitle: string;
  logoUrl: string;
  faviconUrl: string;
  image: string;
  colors: {
    primaryLightest: string;
    primaryLighter: string;
    primary: string;
    primaryDarker: string;
    primaryDarkest: string;
    logoColor: string;
    buttonColor: string,
    navBarTextColor: string,
    bookingStepsTextColor: string,
    bookingStepsTextAccentColor: string,
  };
};

const initialState: TenantState = {
  id: 1,
  name: '',
  siteTitle: '',
  logoUrl: '',
  faviconUrl: '',
  image: '',
  colors: {
    primaryLightest: '',
    primaryLighter: '',
    primary: '',
    primaryDarker: '',
    primaryDarkest: '',
    logoColor: '',
    buttonColor: '',
    navBarTextColor: '',
    bookingStepsTextColor: '',
    bookingStepsTextAccentColor: '',
  },
};

export const tenantSlice = createSlice({
  name: 'tenant',
  initialState,

  reducers: {
    setTenant(state, action: PayloadAction<TenantState>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setTenant } = tenantSlice.actions;
export default tenantSlice.reducer;
